export default "__VITE_ASSET__BJKnDWQR__"